import {ReportTableHeader} from '../components/Table/types';
import moment from 'moment';
import React from 'react';

function useMonthHeaders(queryMonth: string): ReportTableHeader[] {
  const splited = queryMonth?.split('-');
  const year = splited?.length > 1 ? Number(splited[0]) : moment().year();
  const month = splited?.length > 1 ? Number(splited[1]) : moment().month();
  const startDate = moment([year, month - 1]);
  const endDate = moment(startDate).endOf('month');

  const headers: ReportTableHeader[] = [`${year}年${month}月`, '合計'];

  let day = moment(startDate);

  while (day <= endDate) {
    const dayOfWeek = day.format('dd');
    const formattedDate = `${day.date()}(${dayOfWeek})`;

    if (dayOfWeek === '土') {
      headers.push({
        header: <span className="text-blue-500">{formattedDate}</span>,
      });
    } else if (dayOfWeek === '日') {
      headers.push({
        header: <span className="text-red-500">{formattedDate}</span>,
      });
    } else {
      headers.push(formattedDate);
    }

    day.add(1, 'days');
  }

  return headers;
}

export default useMonthHeaders;
